import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { fetchContent, fetchCategories, fetchMenuItems } from "./api";

const ContentContext = createContext({
    content: {},
    categories: [],
    menuItems: [],
    loading: true,
    refresh: () => {},
});

export const ContentProvider = ({ children }) => {
    const [content, setContent] = useState({});
    const [categories, setCategories] = useState([]);
    const [menuItems, setMenuItems] = useState([]);
    const [loading, setLoading] = useState(true);

    const load = useCallback(async () => {
        try {
            const [c, cats, items] = await Promise.all([fetchContent(), fetchCategories(), fetchMenuItems()]);
            setContent(c || {});
            setCategories(cats || []);
            setMenuItems(items || []);
        } catch (e) {
            // fail silently — components fall back to their static defaults
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        load();
    }, [load]);

    return (
        <ContentContext.Provider value={{ content, categories, menuItems, loading, refresh: load }}>
            {children}
        </ContentContext.Provider>
    );
};

export const useContent = () => useContext(ContentContext);

// Convenience helper: dot-path read with fallback
export const useContentValue = (path, fallback) => {
    const { content } = useContent();
    const parts = path.split(".");
    let cur = content;
    for (const p of parts) {
        if (cur == null) return fallback;
        cur = cur[p];
    }
    return cur === undefined ? fallback : cur;
};
